module.exports = __webpack_public_path__ + "static/media/pearson.cb77d5a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pearson.png
// module id = 806
// module chunks = 0